import { SiteSettingsContext } from '@core/shared';
import { getSiteSettings } from '@online-webinar/router';
import { FC, ReactNode, useMemo } from 'react';

export const SiteSettingsProvider: FC<{ children: ReactNode }> = ({ children }) => {
    // Memoize site settings to prevent unnecessary re-renders of consuming components when the provider re-renders for other reasons.
    const siteSettings = useMemo(() => getSiteSettings(), []);
    return <SiteSettingsContext.Provider value={siteSettings}>{children}</SiteSettingsContext.Provider>;
};
